import { getStudentClassInfo } from 'approot/shared/api/auth/student-user-auth';
import { getStudentData } from 'approot/student-class-to-do/student-class-to-do.utils';

export function getStudentClassToDoClassId() {
  const studentClassInfo = getStudentClassInfo();
  if (studentClassInfo) {
    return studentClassInfo.classId;
  } else {
    const classToDoUser = getStudentData();
    return classToDoUser.teacherClassId;
  }
}
